<div class="flex w-full flex-col gap-1">
  @if (label()) {
    @if (!labelTemplate()) {
      <span>{{ label() }}</span>
    } @else {
      <ng-container
        [ngTemplateOutlet]="labelTemplate()"
        [ngTemplateOutletContext]="{ $implicit: label() }" />
    }
  }
  <div
    id="dropdown-container"
    class="hover:bg-theme-gray-400 relative h-full w-full cursor-pointer rounded-[4px] border px-2 py-1"
    [ngClass]="{
      'border-theme-secondary-gray': !showError(),
      'border-error': showError(),
      '!bg-theme-gray-400 !cursor-not-allowed opacity-60': disabled(),
      'bg-theme-gray-400 ring-error ring-1': isOpened() && showError(),
      'bg-theme-gray-400 ring-theme-secondary-gray ring-1': isOpened() && !showError(),
    }"
    role="button"
    tabindex="0"
    (click)="toggleMenu()"
    (keydown.enter)="$event.preventDefault()"
    (keydown.space)="$event.preventDefault()"
    #menuButton>
    <div class="flex w-full justify-between gap-2" [ngClass]="disabled() ? 'opacity-60' : ''">
      <div class="flex w-full justify-start overflow-hidden" style="flex-shrink: 1">
        <span
          class="flex items-center truncate"
          [ngClass]="{ '!text-gray-500': !selectedOption() }">
          {{ selectedOption()?.label ?? placeholder() }}
        </span>
      </div>
      <span class="material-icons flex-shrink-0">
        @if (isOpened()) {
          expand_less
        } @else {
          expand_more
        }
      </span>
    </div>
    @if (isOpened()) {
      <div
        class="absolute top-full right-0 left-0 z-1000 flex flex-col rounded bg-white shadow-[0px_2px_4px_rgba(0,0,0,0.33)]">
        @if (enableSearch()) {
          <shared-ui-text-field
            class="p-2"
            placeholder="Suche..."
            (click)="$event.stopPropagation()"
            (keydown.space)="$event.stopImmediatePropagation()"
            (keydown.enter)="$event.stopPropagation()"
            [formField]="searchStringForm">
            <span class="material-icons">search</span>
          </shared-ui-text-field>
        }
        @if (enableAddButton()) {
          <div class="flex flex-col gap-y-2 p-2">
            <shared-ui-text-field
              [placeholder]="addInputPlaceholder()"
              (click)="$event.stopPropagation()"
              (keydown.space)="$event.stopPropagation()"
              (keydown.enter)="$event.stopPropagation()"
              [formField]="customValueForm">
              <span class="material-icons">add</span>
            </shared-ui-text-field>
            <button sharedCoreButton variant="primary" (click)="addOption()">Hinzufügen</button>
          </div>
        }
        @for (option of filteredOptions(); track $index) {
          <button
            class="flex rounded px-2 py-1 transition hover:bg-[#E9F4F8] hover:font-medium hover:text-[#3D85A2] focus:bg-[#E9F4F8] focus:font-medium focus:text-[#3D85A2]"
            [ngClass]="{ 'bg-[#E9F4F8] font-medium text-[#3D85A2]': option === selectedOption() }"
            (click)="onValueSelected(option); $event.stopPropagation()">
            <div class="flex w-full justify-start">
              <span class="truncate">{{ option.label }}</span>
            </div>
          </button>
        }
        @if (amountHiddenOptions() !== 0) {
          <span class="pb-2 text-sm text-gray-500"
            >{{ amountHiddenOptions() }} Elemente ausgeblendet</span
          >
        }
      </div>
    }
  </div>
  @if (showError()) {
    @for (error of validationErrors(); track error) {
      <span class="text-error">{{ error.message }}</span>
    }
  }
</div>
